<template>
  <v-container />
</template>

<script>
import CookieHelper from "@/helpers/CookieHelper";

export default {
  name: "RegisterConfirm",
  beforeCreate() {
    this.confirm_token = this.$route.params.token;
    this.$store
      .dispatch("user/confirmRegistration", this.confirm_token)
      .then(() => {
        this.$store.commit("viewstate/notify", {
          color: "success",
          text: this.$t("success.successfully_activated_user")
        });

        CookieHelper.setCookie("user", "authorized", 1);
        localStorage.setItem("authorized", "true");

        this.$router.push({ name: this.$store.state.config.main_page });
      })
      .catch(() => {
        this.$store.commit("viewstate/notify", {
          color: "error",
          text: this.$t("error.user_not_found")
        });
        this.$router.push("/");
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
